import { render } from "./medecinSession.vue?vue&type=template&id=0edc1117&scoped=true"
import script from "./medecinSession.vue?vue&type=script&lang=js"
export * from "./medecinSession.vue?vue&type=script&lang=js"

import "./medecinSession.vue?vue&type=style&index=0&id=0edc1117&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edc1117"]])

export default __exports__